import styled from 'styled-components';
import { contiOrange } from '../../../style/colors';

export const Container = styled.div`
  width: 100%;
  padding: 0;
`;

export const StatusSection = styled.div`
  padding: 16px 20px;
  background: white;
  border-bottom: 2px solid #e8e8e8;
  margin-bottom: 16px;
`;

export const StatusLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #666;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
`;

export const OrderItemsGrid = styled.div`
  display: grid;
  gap: 12px;
`;

export const OrderItem = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 16px 24px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${contiOrange};
    box-shadow: 0 2px 8px rgba(255, 165, 0, 0.1);
  }
`;

export const ItemField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #999;
  letter-spacing: 0.3px;
`;

export const FieldValue = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;

